import React, { useEffect } from "react";
import "./header.css";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
const Header = ({ imageSrc, title, navigation }) => {
  const navigate = useNavigate();

  const navigationList = navigation.map((item, index) => (
    <>
      <span
        key={index}
        onClick={index < navigation.length - 1 ? () => navigate(item.path) : undefined}
        className="pageheader-navigation-text"
        style={{ cursor: "pointer" }}
      >
        {item.title}
      </span>
      {index < navigation.length - 1 && <span className="pageheader-navigation-arrow">{">>"}</span>}
    </>
  ));

  useEffect(() => {
    AOS.init({
      disable: function () {
        return window.innerWidth < 900;
      },
    });
  }, []);

  return (
    <div className="pageheader" style={{ backgroundImage: `url(${imageSrc})` }}>
      <div className="pageheader-title">
        <div className="pageheader-title-text" data-aos="fade-up">
          {title}
        </div>
        <div
          className="pageheader-navigation"
          style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
          data-aos="fade-up"
          data-aos-delay="100"
        >
          {navigationList}
        </div>
      </div>
    </div>
  );
};

export default Header;
